import React, { FC } from 'react'
import { FormikHelpers } from 'formik'

import { FormErrorsProps } from '../../form/FormErrors'
import { FormikFormProps } from '../../form/FormikForm'
import { FormSubmitButtonProps } from '../../form/FormSubmitButton'
import FormikField from '../../form/FormikField'
import { FormOTPProps } from '../../form/FormOTP'

import * as SC from './styled'

export type ConfirmationFormValues = {
  emailCode: string
}

export type ConfirmationFormProps = {
  className?: string
  formik: FormikFormProps<ConfirmationFormValues>
  fields: {
    emailCode: FormOTPProps
  }
  title: string
  email: {
    title: string
    description: string
  }
  resend: {
    label: string
    disabled?: boolean
    onClick?: () => void
  }
  errors?: FormErrorsProps['errors']
  submitButton: FormSubmitButtonProps
  onSubmit?: (
    values: ConfirmationFormValues,
    formikHelpers: FormikHelpers<ConfirmationFormValues>
  ) => void
}

const RegisterForm: FC<ConfirmationFormProps> = ({
  className,
  formik,
  fields,
  title,
  email,
  resend,
  submitButton,
  errors,
}) => {
  return (
    <SC.Form className={className} {...formik}>
      <SC.Title>{title}</SC.Title>
      <SC.FieldTitle>{email.title}</SC.FieldTitle>
      <SC.FieldDescription>{email.description}</SC.FieldDescription>
      <FormikField {...fields.emailCode} Component={SC.FieldFormOTP} />
      <SC.Resend
        onClick={resend.disabled ? undefined : resend.onClick}
        $disabled={!!resend.disabled}
      >
        {resend.label}
      </SC.Resend>
      {errors && <SC.Errors errors={errors} />}
      <SC.Center>
        <SC.SubmitButton {...submitButton} variant="secondary" />
      </SC.Center>
    </SC.Form>
  )
}

export default RegisterForm
